import { StatusCodes } from "http-status-codes";
import { request } from "../../api";
import { headers } from "../../../../config/config";
import { MESSAGE } from "../../../../constants/api/message";
import { AUTHORIZATION } from "../../../../constants/api/auth";
import { Paycheck } from "../../../../@types/paycheck.types";
const { post } = request;
const { Authorization, Bearer } = AUTHORIZATION;

const initialRoute = "member";

export const addPaycheck = async (_payload: Paycheck) => {
	try {
		const payload = JSON.stringify(_payload);
		const endpoint = `${initialRoute}/paycheck/add-paycheck`;
		const token = localStorage.getItem("@jwt");
		const response = await post(endpoint, payload, {
			...headers,
			[Authorization]: `${Bearer} ${token}`
		});
		if (response) {
			const {
				data: { message }
			} = response;
			if (message === MESSAGE.post.succ) {
				const {
					data: { result }
				} = response;
				return result;
			}
		}
		throw new Error();
	} catch (error: any) {
		if (error.response.status === StatusCodes.BAD_REQUEST) {
			const { message } = error.response.data;

			if (message === "Employee doesnot exists!") {
				alert("Employee doesnot exists!");
			} else if (message === "Paycheck End Date can not be before than Paycheck Start Date!") {
				alert("Paycheck End Date can not be before than Paycheck Start Date!");
			} else if (message === "Employment Start Date can not be before than Hire date!") {
				alert("Employment Start Date can not be before than Hire date!");
			} else if (
				message === "Employment Start Date and Paycheck Start Date must be same during Add Employment!"
			) {
				alert("Employment Start Date and Paycheck Start Date must be same during Add Employment!");
			} else if (
				message === "Employment Start Date and Paycheck Start Date must be same during Add Employment!"
			) {
				alert("Employment Start Date and Paycheck Start Date must be same during Add Employment!");
			} else if (message === MESSAGE.post.fail) {
				alert("Failed to Create Employee!");
			} else alert("Other Errors of Status Code 400");
		} else {
			throw error;
		}
	}
};
